<section class="active-products">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Mis seguros</h2>
            <a class="section-link" (click)="irA('/insurances')">Ver todos mis seguros</a>
        </div>
        <div class="product-list" *ngIf="loading">
            <div class="product-card product-card--skeleton" *ngFor="let s of skeletonSlots">
                <span class="skeleton skeleton-circle"></span>
                <div class="product-card-body">
                    <div class="product-card-head">
                        <span class="skeleton skeleton-line skeleton-line--title"></span>
                        <span class="skeleton skeleton-tag"></span>
                    </div>
                    <span class="skeleton skeleton-line skeleton-line--md"></span>
                    <span class="skeleton skeleton-line skeleton-line--lg"></span>
                </div>
            </div>
        </div>
        <div class="product-list" *ngIf="!loading">
            <div class="product-card" *ngFor="let producto of items">
                <div class="product-card-icon" aria-hidden="true">
                    <img class="product-card-icon-img" [src]="iconForProduct(producto)" alt="">
                </div>
                <div class="product-card-body">
                    <div class="product-card-head">
                        <h3 class="product-card-title">{{ producto.nombre }}</h3>
                        <span class="product-card-tag">{{ producto.estado }}</span>
                    </div>
                    <p class="product-card-line">
                        <span>Nº de póliza </span><strong>{{ producto.poliza }}</strong>
                    </p>
                    <p class="product-card-line">
                        <span>Vigencia </span><strong>{{ producto.vigencia }}</strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
